
// @ts-nocheck
import locale_en_46json_5da60b9b from "#nuxt-i18n/5da60b9b";
import locale_errors_46json_d89b5330 from "#nuxt-i18n/d89b5330";
import locale_pt_46json_a0d5c28e from "#nuxt-i18n/a0d5c28e";
import locale_errors_46json_fbec8a5e from "#nuxt-i18n/fbec8a5e";

export const localeCodes =  [
  "en",
  "pt"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_5da60b9b",
      load: () => Promise.resolve(locale_en_46json_5da60b9b),
      cache: true
    },
    {
      key: "locale_errors_46json_d89b5330",
      load: () => Promise.resolve(locale_errors_46json_d89b5330),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_a0d5c28e",
      load: () => Promise.resolve(locale_pt_46json_a0d5c28e),
      cache: true
    },
    {
      key: "locale_errors_46json_fbec8a5e",
      load: () => Promise.resolve(locale_errors_46json_fbec8a5e),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/3f925d9b" /* webpackChunkName: "config_i18n_46config_46ts_3f925d9b" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    jit: true,
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-US",
      name: "English",
      files: [
        "/codebuild/output/src1539995266/src/zazos-web/i18n/locales/en.json",
        "/codebuild/output/src1539995266/src/zazos-web/i18n/locales/en/errors.json"
      ]
    },
    {
      code: "pt",
      language: "pt-BR",
      name: "Português",
      files: [
        "/codebuild/output/src1539995266/src/zazos-web/i18n/locales/pt.json",
        "/codebuild/output/src1539995266/src/zazos-web/i18n/locales/pt/errors.json"
      ]
    }
  ],
  defaultLocale: "pt",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: true,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "https://app.zazos.com",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    name: "English",
    files: [
      {
        path: "/codebuild/output/src1539995266/src/zazos-web/i18n/locales/en.json",
        cache: undefined
      },
      {
        path: "/codebuild/output/src1539995266/src/zazos-web/i18n/locales/en/errors.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    language: "pt-BR",
    name: "Português",
    files: [
      {
        path: "/codebuild/output/src1539995266/src/zazos-web/i18n/locales/pt.json",
        cache: undefined
      },
      {
        path: "/codebuild/output/src1539995266/src/zazos-web/i18n/locales/pt/errors.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/